<div class="auth-container">
  <div class="container">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-12 col-sm-12 text-center">
          <img
            src="/assets/images/octopus-logo-white.png"
            alt="Octopus Banner"
            height="100%"
            width="60%"
            />
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-md-12 col-lg-12 col-sm-12 text-center">
          @if (isVerifying) {
            <div class="row">
              <div
                class="col-md-12 d-flex justify-content-center"
                >
                <mat-spinner diameter="24"></mat-spinner>
                <span class="mx-2"
                  >Verifying your response</span
                  >
                </div>
              </div>
            }

            @if (!isVerifying && showError && !response) {
              <h5>
                Oops! We ran into a hiccup updating your account
                status.
              </h5>
              <p class="mt-2">
                Please submit a ticket at:
                <a
                  href="https://playoctopus.com/help"
                  target="_blank"
                  >playoctopus.com/help</a
                  >
                  for assistance updating your account.
                </p>
              }
              @if (!isVerifying && !showError && success) {
                <h5>
                  Thank you for extending your Account Pause. Your
                  account will now remain paused until
                  {{ backToActive }}.
                </h5>
                <br />
                <h6>
                  A confirmation email will be sent to {{ email }}.
                </h6>
                <br />
                <p class="mt-2">
                  Please note, if you drive while your account is
                  paused, your tablet will still record activity and
                  points. Please email contact&#64;playoctopus.com with
                  any questions. Thank you!
                </p>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
